import { gql, makeVar, useQuery } from '@apollo/client'
import { useCounter, useInterval } from 'ahooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

import s from './new-version-banner.module.less'

export const newVersionBanner = makeVar(false)

const NewVersionQuery = gql`
  query {
    newVersionBanner @client
  }
`

export const NewVersionBanner = () => {
  const { data } = useQuery(NewVersionQuery)
  const [t] = useTranslation()
  const [count, { dec }] = useCounter(5, { min: 0 })

  const hasNewVersion = data.newVersionBanner
  useInterval(() => dec(), hasNewVersion ? 1000 : null)

  React.useEffect(() => {
    if (count === 0) {
      window.location.reload()
    }
  }, [count])

  return (
    hasNewVersion && (
      <div className={s.container}>
        {t('newVersionBanner')} ({count})
      </div>
    )
  )
}
